/** i18next's TFunction isn't structurally assignable to a plain callback
 *  (same note as StudentsPage's own KhoaBadgeT) — a plain signature instead. */
export type CapacityT = (key: string, options?: Record<string, unknown>) => string;

export interface CapacityDisplay {
  pill: boolean;
  text: string;
}

/**
 * Sĩ số pill (handoff README decision 3/7, spec §6.15): no cap -> bare
 * count, at cap -> a neutral pill prefixed "Đủ", over cap -> the same
 * neutral pill with no prefix (never blocked, never ochre), under cap ->
 * plain text. Extracted from `ClassListTab` (THI-267 Task 10) so the Xếp
 * lớp dialog's class cards (Task 14) render the identical pill instead of a
 * second copy that could drift from it.
 */
export function capacityDisplay(rosterCount: number, maxCapacity: number | null, t: CapacityT): CapacityDisplay {
  if (maxCapacity == null) return { pill: false, text: String(rosterCount) };
  if (rosterCount === maxCapacity) return { pill: true, text: t('classes.list.full', { count: `${rosterCount}/${maxCapacity}` }) };
  if (rosterCount > maxCapacity) return { pill: true, text: `${rosterCount}/${maxCapacity}` };
  return { pill: false, text: `${rosterCount}/${maxCapacity}` };
}
